import { FC } from 'react';

import ModalDialog from '../ModalDialog';

interface NoteCreatedConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  noteTitle: string;
  clientFirstName?: string;
}

const NoteCreatedConfirmationModal: FC<NoteCreatedConfirmationModalProps> = ({
  isOpen,
  onClose,
  noteTitle,
  clientFirstName,
}) => {
  return (
    <ModalDialog
      title="Private Note Created!"
      isOpen={isOpen}
      setClosed={onClose}
      width="small"
      primaryActionTitle="Okay"
      primaryActionOnClick={onClose}
    >
      <div className="flex flex-col items-center justify-center text-center">
        <p className="text-lg mb-2 font-medium text-neutral-150">
          "{noteTitle}" has been successfully created.
        </p>
        <p className="text-sm text-neutral-125">
          You can find it in the <strong>Private Notes</strong> tab of{' '}
          {clientFirstName ? `${clientFirstName}'s` : "this client's"} record.
        </p>
      </div>
    </ModalDialog>
  );
};

export default NoteCreatedConfirmationModal;
